export const TOAST_MESSAGE_FOR_CREATE_SHIPMENT_AND_UPDATE_BILLING_INFO =
  "お届け先情報と支払い者情報を保存しました。" as const;

export const TOAST_MESSAGE_FOR_ONLY_CREATE_SHIPMENT = "お届け先情報を保存しました。" as const;

export const shipmentAplloErrorTestId = "pages/settings/shipment/ApolloError";
export const shipmentUserInfoTestIdPrefix = "pages/settings/shipment/__components__/FamilyCustomerUserInfo-" as const;
